export default __webpack_public_path__ + "static/uw-platform-icon-147432f35b4de8d2e6641d5f8f32ca7c.png";